export enum TripStatus {
  ABIERTO = 2,
  CARGANDO = 3,
  EN_PROCESO = 4,
  CERRADO = 5,
  LIQUIDANDO = 12,
  FINALIZADO = 13,
  DOC_LIQUIDACION_CREADO = 15,
  DOC_LIQUIDACION_APROBADO = 16
}

export const TRIP_STATUS_LABELS = {
  [TripStatus.ABIERTO]: "Abierto",
  [TripStatus.CARGANDO]: "Cargando",
  [TripStatus.EN_PROCESO]: "En proceso",
  [TripStatus.CERRADO]: "Cerrado",
  [TripStatus.LIQUIDANDO]: "Liquidando",
  [TripStatus.FINALIZADO]: "Finalizado",
  [TripStatus.DOC_LIQUIDACION_CREADO]: "Doc. Liquidación creado",
  [TripStatus.DOC_LIQUIDACION_APROBADO]: "Doc. Liquidación aprobado"
};

export interface TripStatusItem {
  code: TripStatus;
  value: string;
}

export const TRIP_STATUS_LIST: TripStatusItem[] = [
  { code: TripStatus.FINALIZADO, value: TRIP_STATUS_LABELS[TripStatus.FINALIZADO] },
  { code: TripStatus.LIQUIDANDO, value: TRIP_STATUS_LABELS[TripStatus.LIQUIDANDO] },
  { code: TripStatus.DOC_LIQUIDACION_CREADO, value: TRIP_STATUS_LABELS[TripStatus.DOC_LIQUIDACION_CREADO] },
  { code: TripStatus.DOC_LIQUIDACION_APROBADO, value: TRIP_STATUS_LABELS[TripStatus.DOC_LIQUIDACION_APROBADO] },
  { code: TripStatus.ABIERTO, value: TRIP_STATUS_LABELS[TripStatus.ABIERTO] },
  { code: TripStatus.CARGANDO, value: TRIP_STATUS_LABELS[TripStatus.CARGANDO] },
  { code: TripStatus.EN_PROCESO, value: TRIP_STATUS_LABELS[TripStatus.EN_PROCESO] },
  { code: TripStatus.CERRADO, value: TRIP_STATUS_LABELS[TripStatus.CERRADO] }
];

/**
 * Configuración centralizada para los estados de viaje
 * Incluye labels cortos y largos, colores estandarizados e íconos
 */
export interface TripStatusConfig {
  value: TripStatus;
  shortLabel: string;
  longLabel: string;
  badgeClasses: string;
  icon: string;
  filterColor: string;
  filterBgClass: string;
  filterIconClass: string;
}

export const TRIP_STATUS_CONFIG: TripStatusConfig[] = [
  {
    value: TripStatus.ABIERTO,
    shortLabel: "Abierto",
    longLabel: "Abierto",
    badgeClasses:
      "bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50",
    icon: "heroicons_solid:play-circle",
    filterColor: "rgb(65, 106, 218)",
    filterBgClass: "bg-blue-200",
    filterIconClass: "text-blue-800",
  },
  {
    value: TripStatus.CARGANDO,
    shortLabel: "Cargando",
    longLabel: "Cargando",
    badgeClasses:
      "bg-yellow-200 text-yellow-800 dark:bg-yellow-600 dark:text-yellow-50",
    icon: "heroicons_solid:cube",
    filterColor: "rgb(236, 199, 58)",
    filterBgClass: "bg-yellow-200",
    filterIconClass: "text-yellow-800",
  },
  {
    value: TripStatus.EN_PROCESO,
    shortLabel: "En proceso",
    longLabel: "En proceso",
    badgeClasses:
      "bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50",
    icon: "heroicons_solid:truck",
    filterColor: "rgb(233, 124, 61)",
    filterBgClass: "bg-orange-200",
    filterIconClass: "text-orange-800",
  },
  {
    value: TripStatus.CERRADO,
    shortLabel: "Cerrado",
    longLabel: "Cerrado",
    badgeClasses:
      "bg-gray-300 text-gray-800 dark:bg-gray-600 dark:text-gray-50",
    icon: "heroicons_solid:lock-closed",
    filterColor: "rgb(80, 77, 77)",
    filterBgClass: "bg-gray-300",
    filterIconClass: "text-gray-800",
  },
  {
    value: TripStatus.LIQUIDANDO,
    shortLabel: "Liquidando",
    longLabel: "Liquidando",
    badgeClasses:
      "bg-pink-200 text-pink-900 dark:bg-pink-700 dark:text-pink-50",
    icon: "heroicons_solid:calculator",
    filterColor: "rgb(141, 19, 19)",
    filterBgClass: "bg-pink-200",
    filterIconClass: "text-pink-900",
  },
  {
    value: TripStatus.FINALIZADO,
    shortLabel: "Finalizado",
    longLabel: "Finalizado",
    badgeClasses:
      "bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50",
    icon: "heroicons_solid:check-badge",
    filterColor: "rgb(9, 133, 50)",
    filterBgClass: "bg-green-200",
    filterIconClass: "text-green-800",
  },
  {
    value: TripStatus.DOC_LIQUIDACION_CREADO,
    shortLabel: "Liq. creada",
    longLabel: "Documento de liquidación creado",
    badgeClasses:
      "bg-blue-300 text-blue-900 dark:bg-blue-800 dark:text-blue-50",
    icon: "heroicons_solid:document-text",
    filterColor: "rgb(19, 41, 141)",
    filterBgClass: "bg-blue-300",
    filterIconClass: "text-blue-900",
  },
  {
    value: TripStatus.DOC_LIQUIDACION_APROBADO,
    shortLabel: "Liq. aprobada",
    longLabel: "Documento de liquidación aprobado",
    badgeClasses:
      "bg-green-300 text-green-900 dark:bg-green-800 dark:text-green-50",
    icon: "heroicons_solid:check-circle",
    filterColor: "rgb(17, 125, 49)",
    filterBgClass: "bg-green-300",
    filterIconClass: "text-green-900",
  },
];

/**
 * Helper function para obtener la configuración de un estado por su valor
 */
export function getTripStatusConfig(statusId: TripStatus): TripStatusConfig | undefined {
  return TRIP_STATUS_CONFIG.find(config => config.value === statusId);
}